// import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useEffect,useLayoutEffect } from 'react'
import home_1 from "../../assets/home/home_1.jpg";
import home_2 from "../../assets/home/home_2.jpg";
import home_3 from "../../assets/home/home_3.jpg";
import home_4 from "../../assets/home/home_4.jpg";
import HomeImgComp from "./HomeImgComp";
import HomePageComp from "./HomePageComp";
import "../../styles/pagesStyles/home.css";
import styles from "../../styles/componentStyles/homeTransition.module.css";
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import useBreakpoints from "../../customHook/useBreakpoints";
// import { useLocomotiveScroll } from "react-locomotive-scroll";
// import ScrollTriggerProxy from '../../customHook/ScrollTriggerProxy';

const Home = ({ show = false }) => {
	gsap.registerPlugin(ScrollTrigger);

	const { isXX } = useBreakpoints();

	useLayoutEffect(() => {
		gsap.utils.toArray(".home_image_section").forEach((section) => {
			// Check if section has horizontal scrolling
			if (section.dataset.type === "horizontal") {
				const cards = section.querySelector(".pin-wrap");
				const card = section.querySelector(".pin_card");

				gsap.to(cards, {
					x: () => {
						return -cards.scrollWidth + card.offsetWidth;
					},
					ease: "none",
					scrollTrigger: {
						trigger: section,
						start: () => "center center",
						end: () => `+=${cards.scrollWidth - card.offsetWidth}`,
						scrub: true,
						pin: true,
						invalidateOnRefresh: true,
						// anticipatePin: 1,
					},
				});
				// Use standard vertical scroll pinning
			} else {
				ScrollTrigger.create({
					// markers: true,
					trigger: section,
					start: () => "top top",
					end: () => "bottom bottom",
					// pin: true,
					anticipatePin: 1
				});
			}
		});

		setTimeout(() => {
		    ScrollTrigger.refresh()
		}, 100);
		return () => {
			ScrollTrigger.addEventListener("refresh", () => ScrollTrigger.update());
			ScrollTrigger.refresh();
		};
		// Use standard vertical scroll pinning
	}, [isXX]);

	useEffect(() => {
		setTimeout(() => {
			ScrollTrigger.refresh();
		}, 100);
	}, [isXX]);

	return (
		<div className={`explore_section ${styles.explore_page}`}>
			<div className="home_image___container">
				<HomeImgComp className="home_image_section" home_c_img="home_c_img1" id="home_c_img2" homeimg={home_1} to="/architecture" btn="Architecture" />
				<HomeImgComp className="home_image_section" home_c_img="home_c_img2" id={isXX ? "home_c_img5" : "home_c_img3"} homeimg={home_2} to="/experience" btn="Experiences" />
				{isXX ? (
					<div>
						<HomeImgComp
							className="home_image_section"
							home_c_img="home_c_img5"
							id="home_c_img6"
							homeimg={home_3}
							to="/work_with_us"
							btn="Work With Us"
						/>
						<HomeImgComp
							className="home_image_section"
							home_c_img="home_c_img6"
							id="Home_Page"
							homeimg={home_4}
							to="/properties"
							btn="Stay"
						/>
					</div>
				) : (
					<div
						id="sectionPin"
						className="home_image_section pinned_section"
						data-type="horizontal"
					>
						<div className="pin-wrap">
							<HomeImgComp
								className="pin_card"
								home_c_img="home_c_img3"
								id="home_c_img4"
								homeimg={home_3}
								to="/work_with_us"
								btn="Work with us"
							/>
							<HomeImgComp
								className="pin_card"
								home_c_img="home_c_img4"
								id="Home_Page"
								homeimg={home_4}
								to="/properties"
								btn="Stay"
							/>
						</div>
					</div>
				)}
			</div>
			<HomePageComp />
		</div>
	);
};

export default Home;